<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">PTP Workflow Steps</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button nzType="primary" (click)="addStep()">Add Step</button>
        </div>
        <nz-table #stepTable [nzData]="steps" nzTableLayout="fixed" nzBordered="true" [nzLoading]="loading">
            <thead>
                <tr>
                    <th nzWidth="90px">Order</th>
                    <th>Name</th>
                    <th>Step Type</th>
                    <th nzWidth="120px">Dollar Amount</th>
                    <th nzWidth="100px">Show Create</th>
                    <th nzWidth="220px"></th>
                </tr>
            </thead>
            <tbody>
                @for (step of stepTable.data; track step.StepID) {
                    <tr>
                        <td>{{ step.Order }}</td>
                        <td>{{ step.StepName }}</td>
                        <td>{{ step.stepTypeLabel }}</td>
                        <td>{{ step.DollarAmount }}</td>
                        <td>{{ step.ShowCreate ? "Yes" : "No" }}</td>
                        <td style="text-align: center">
                            <button
                                nz-button
                                class="btn btn-default"
                                title="Move up"
                                (click)="reorder(step.StepID, step.Order - 1)">
                                ↑
                            </button>
                            <button
                                nz-button
                                class="btn btn-default"
                                style="margin-left: 4px"
                                title="Move down"
                                (click)="reorder(step.StepID, step.Order + 1)">
                                ↓
                            </button>
                            <button
                                nz-button
                                class="btn btn-default"
                                style="margin-left: 8px"
                                (click)="editStep(step.StepID)">
                                Edit
                            </button>
                            <button
                                nz-button
                                nzDanger
                                style="margin-left: 8px"
                                nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to delete this step?"
                                (nzOnConfirm)="deleteStep(step.StepID)">
                                Delete
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>
